"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = exports.toBig = exports.split = exports.fromBig = void 0;
var U32_MASK64 = BigInt(Math.pow(2, 32) - 1);

var _32n = BigInt(32); // We are not using BigUint64Array, because they are extremely slow as per 2022


function fromBig(n) {
  var le = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (le) return {
    h: Number(n & U32_MASK64),
    l: Number(n >> _32n & U32_MASK64)
  };
  return {
    h: Number(n >> _32n & U32_MASK64) | 0,
    l: Number(n & U32_MASK64) | 0
  };
}

exports.fromBig = fromBig;

function split(lst) {
  var le = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var Ah = new Uint32Array(lst.length);
  var Al = new Uint32Array(lst.length);

  for (var i = 0; i < lst.length; i++) {
    var _fromBig = fromBig(lst[i], le),
        h = _fromBig.h,
        l = _fromBig.l;

    var _ref = [h, l];
    Ah[i] = _ref[0];
    Al[i] = _ref[1];
  }

  return [Ah, Al];
}

exports.split = split;

var toBig = function toBig(h, l) {
  return BigInt(h >>> 0) << _32n | BigInt(l >>> 0);
};

exports.toBig = toBig; // for Shift in [0, 32)

var shrSH = function shrSH(h, l, s) {
  return h >>> s;
};

var shrSL = function shrSL(h, l, s) {
  return h << 32 - s | l >>> s;
}; // Right rotate for Shift in [1, 32)


var rotrSH = function rotrSH(h, l, s) {
  return h >>> s | l << 32 - s;
};

var rotrSL = function rotrSL(h, l, s) {
  return h << 32 - s | l >>> s;
}; // Right rotate for Shift in (32, 64), NOTE: 32 is special case.


var rotrBH = function rotrBH(h, l, s) {
  return h << 64 - s | l >>> s - 32;
};

var rotrBL = function rotrBL(h, l, s) {
  return h >>> s - 32 | l << 64 - s;
}; // Right rotate for shift===32 (just swaps l&h)


var rotr32H = function rotr32H(h, l) {
  return l;
};

var rotr32L = function rotr32L(h, l) {
  return h;
}; // Left rotate for Shift in [1, 32)


var rotlSH = function rotlSH(h, l, s) {
  return h << s | l >>> 32 - s;
};

var rotlSL = function rotlSL(h, l, s) {
  return l << s | h >>> 32 - s;
}; // Left rotate for Shift in (32, 64), NOTE: 32 is special case.


var rotlBH = function rotlBH(h, l, s) {
  return l << s - 32 | h >>> 64 - s;
};

var rotlBL = function rotlBL(h, l, s) {
  return h << s - 32 | l >>> 64 - s;
}; // JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
// Removing "export" has 5% perf penalty -_-


function add(Ah, Al, Bh, Bl) {
  var l = (Al >>> 0) + (Bl >>> 0);
  return {
    h: Ah + Bh + (l / Math.pow(2, 32) | 0) | 0,
    l: l | 0
  };
}

exports.add = add; // Addition with more than 2 elements

var add3L = function add3L(Al, Bl, Cl) {
  return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
};

var add3H = function add3H(low, Ah, Bh, Ch) {
  return Ah + Bh + Ch + (low / Math.pow(2, 32) | 0) | 0;
};

var add4L = function add4L(Al, Bl, Cl, Dl) {
  return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
};

var add4H = function add4H(low, Ah, Bh, Ch, Dh) {
  return Ah + Bh + Ch + Dh + (low / Math.pow(2, 32) | 0) | 0;
};

var add5L = function add5L(Al, Bl, Cl, Dl, El) {
  return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
};

var add5H = function add5H(low, Ah, Bh, Ch, Dh, Eh) {
  return Ah + Bh + Ch + Dh + Eh + (low / Math.pow(2, 32) | 0) | 0;
}; // prettier-ignore


var u64 = {
  fromBig: fromBig,
  split: split,
  toBig: exports.toBig,
  shrSH: shrSH,
  shrSL: shrSL,
  rotrSH: rotrSH,
  rotrSL: rotrSL,
  rotrBH: rotrBH,
  rotrBL: rotrBL,
  rotr32H: rotr32H,
  rotr32L: rotr32L,
  rotlSH: rotlSH,
  rotlSL: rotlSL,
  rotlBH: rotlBH,
  rotlBL: rotlBL,
  add: add,
  add3L: add3L,
  add3H: add3H,
  add4L: add4L,
  add4H: add4H,
  add5H: add5H,
  add5L: add5L
};
exports.default = u64;